import { MeasurementException } from '@features/ForestOwner/Search/Overview/ContactPreferences/MeasurementException'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const searchSchema = z.object({
  supplierNumber: z.string().optional(),
})

export const Route = createFileRoute('/forestowner/$forestownerId/contactpreferences/exceptions/')({
  component: RouteComponent,
  validateSearch: searchSchema,
  staticData: {
    breadcrumb: 'Måledokumenter',
  },
})

function RouteComponent() {
  const search = Route.useSearch()
  return <MeasurementException initialSupplierNumber={search.supplierNumber} />
}
